<div class="scrollable-container">
  <!-- Header-->
  @if (!noHeader) {
    <div class="scrollable-container-header flex-row justify-center align-center" [ngStyle]="headerStyle">
      <ng-content select="[header]" ]></ng-content>
    </div>
  }
  <!-- Content-->
  <div class="scrollable-container-content" [ngClass]="{'no-padding': noPadding}">
    <ng-content select="[content]"></ng-content>
  </div>
  <!-- Footer-->
  @if (!noFooter) {
    <div class="scrollable-container-footer flex-row justify-center align-center" [ngStyle]="footerStyle">
      <ng-content select="[footer]"></ng-content>
    </div>
  }
</div>
